import { createClient } from '@supabase/supabase-js'

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables')
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true
  }
})

// Helper function to get current session
export const getCurrentSession = () => supabase.auth.getSession()

// Helper function to get current user
export const getCurrentUser = async () => {
  const { data: { session } } = await getCurrentSession()
  return session?.user ?? null
}

// Helper function to get auth token
export const getAuthToken = async () => {
  const { data: { session } } = await getCurrentSession()
  return session?.access_token ?? null
} 